<template>
  <nav :class="[
    'navigation-bar z-50 transition-all duration-300 ease-in-out', 
    suckClass,
    { 
      'fixed top-0 left-0 right-0 w-full h-16 shadow-md bg-slate-900/90 backdrop-blur-md': !isHomePage, 
      'fixed bottom-8 left-1/2 -translate-x-1/2 w-[85%] max-w-2xl h-16 rounded-full shadow-2xl bg-slate-800/90 backdrop-blur-md border border-slate-700 animate-float': isHomePage 
    }
  ]">
    <div class="h-full flex items-center justify-between px-6" :class="{'justify-center': isHomePage}">
      <!-- 品牌标志 -->
      <div>
        <router-link to="/" class="flex items-center text-decoration-none group">
          <span class="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">xiaoyang</span>
          <span class="w-2 h-2 bg-blue-500 rounded-full ml-1 animate-pulse"></span>
        </router-link>
      </div>

      <!-- 中间链接 -->
      <div class="flex items-center space-x-1 md:space-x-4">
        <router-link to="/" class="px-3 py-2 text-slate-300 hover:text-blue-300 transition-colors relative font-medium text-sm md:text-base" active-class="text-blue-400 font-semibold">主页</router-link>
        <router-link to="/opensource" class="px-3 py-2 text-slate-300 hover:text-blue-300 transition-colors relative font-medium text-sm md:text-base" active-class="text-blue-400 font-semibold">开源项目</router-link>
        <router-link to="/plan" class="px-3 py-2 text-slate-300 hover:text-blue-300 transition-colors relative font-medium text-sm md:text-base" active-class="text-blue-400 font-semibold">食程计划</router-link>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { uiState } from '@/state/ui'

const route = useRoute()

// 计算是否为首页（用于导航栏模式切换）
const isHomePage = computed(() => 
  route.path === '/' && !route.hash
)

const suckClass = computed(() => {
  if (!uiState.isTornadoActive) return ''
  return isHomePage.value ? 'suck-floating' : 'suck-fixed'
})
</script>

<style scoped>
@keyframes float {
  0%, 100% {
    transform: translateX(-50%) translateY(0);
  }
  50% {
    transform: translateX(-50%) translateY(-10px);
  }
}

.animate-float {
  animation: float 4s ease-in-out infinite;
}

/* 龙卷风吸入动画 - 悬浮导航栏 */
@keyframes suckFloating {
  0% { transform: translateX(-50%) scale(1) rotate(0); opacity: 1; }
  100% { transform: translateX(-50%) scale(0) rotate(720deg); opacity: 0; }
}
.suck-floating {
  animation: suckFloating 1.5s ease-in forwards !important;
}

/* 龙卷风吸入动画 - 固定导航栏 */
@keyframes suckFixed {
  0% { transform: translateY(0) scale(1); opacity: 1; }
  100% { transform: translateY(50vh) scale(0) rotate(720deg); opacity: 0; }
}
.suck-fixed {
  animation: suckFixed 1.5s ease-in forwards !important;
}
</style>
